import React from 'react';
import ApolloClient from 'apollo-boost';
import { ApolloProvider } from '@apollo/react-hooks';
import Layout from '../components/layout';
import SEO from '../components/seo';
import { SettingProvider } from '../lib/context/settings';
import { AdsProvider } from '../lib/context/ads';

import { Button, Col, Row, Form, Input, InputNumber } from 'antd';
import styled from 'styled-components';
import { SecondaryTitle, Title } from '../components/styles';
import { device } from '../lib/theme';

const client = new ApolloClient<any>({
  uri: `https://${process.env.GATSBY_WORDPRESS_URL_PATH}/graphql`,
  fetchOptions: {
    credentials: 'include',
  },
});

const HeroContainer = styled(Row)`
  background-image: url('https://aaacdndev.blob.core.windows.net/wordpress/2021/07/Screenshot-2021-07-23-133755.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  height: 300px;
  margin: auto;
`;

const CTAButton = styled(Button)`
  width: 100%;
  margin-top: 32px;
  margin-bottom: 64px;

  @media ${device.tablet} {
    width: initial;
  }
`;

const ImgCars = styled.img`
  width: 100%;
  @media ${device.tablet} {
    width: 350px;
  }
  @media ${device.laptop} {
    width: 500px;
  }
`;

const ContactUsFormRow = styled(Row)`
  background-color: #0000000d;
  padding: 64px 0;
`;

const CarMobileCol = styled(Col)`
  background-image: url('https://aaacdndev.blob.core.windows.net/wordpress/2020/03/four-white-cars-resized.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 150px;
`;

const CarCareFleetServicesPage: React.FC<any> = () => {
  const [form] = Form.useForm();

  const handleFormSubmit = (values: any) => {
    const body = new FormData();
    const keys = Object.keys(values);
    for (const key of keys) {
      body.append(key, values[key]);
    }
    console.log('handleFormSubmit', values);
    fetch(
      'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8',
      {
        method: 'POST',
        body,
        mode: 'no-cors',
      }
    )
      .then((i) => i.text())
      .then((res) => {
        console.log('res', res);
        form.resetFields();
      });
  };

  return (
    <ApolloProvider client={client as any}>
      <SettingProvider>
        <AdsProvider>
          <Layout key={`${typeof window}`}>
            <SEO
              title="Car Care Fleet Services | AAA"
              description="AAA Car Care understands the importance of keeping your company fleet on the road and generating revenue for your business."
              canonicalUrl="/car-care-fleet-services"
            />
            <HeroContainer align="middle">
              <Col xs={{ span: 22, offset: 1 }} md={{ span: 20, offset: 2 }}>
                <p
                  style={{
                    fontSize: 24,
                    color: 'white',
                    marginBottom: 0,
                    marginTop: 24,
                  }}
                >
                  AAA Car Care
                </p>
                <Title white>Fleet Services</Title>

                <CTAButton
                  href="/car-care-fleet-services/#contact-us"
                  type="primary"
                >
                  Request Contact
                </CTAButton>
              </Col>
            </HeroContainer>
            <Row>
              <Col xs={{ span: 22, offset: 1 }} md={{ span: 20, offset: 2 }}>
                <Row style={{ marginTop: 64 }}>
                  <Col xs={{ span: 24 }} md={{ span: 12 }}>
                    <p>
                      Are you in need of a reliable auto repair and maintenance
                      shop to handle your fleet vehicle service needs? AAA has
                      been trusted in automotive for over 100 years, and we
                      understand the importance of keeping your company fleet on
                      the road and generating revenue for your business.
                    </p>
                    <p>
                      We have 34 Car Care locations across the Carolinas that
                      offer full auto repair services, expert technicians and
                      transparency at each visit.
                    </p>
                    <p>
                      <strong>Fleet Service Benefits at AAA Car Care:</strong>
                    </p>
                    <ul>
                      <li>
                        Easy appointment scheduling for services. Our team is
                        available 24/7 to schedule appointments.
                      </li>
                      <li>
                        Pickup and delivery of fleet vehicles (where applicable)
                        and access to free rideshare service keeps your
                        employees on the job.
                      </li>
                      <li>
                        2-year/24,000-mile parts and labor warranty on
                        mechanical repairs nationwide.
                      </li>
                      <li>
                        Complimentary multi-point digital vehicle inspection
                        conducted at every service visit.
                      </li>
                    </ul>
                    <p>
                      <strong>
                        Get your fleet protected by the trusted brand in
                        automotive.
                      </strong>
                    </p>
                    <CTAButton
                      href="/car-care-fleet-services/#contact-us"
                      type="primary"
                    >
                      Request Contact
                    </CTAButton>
                  </Col>
                  <Col xs={{ span: 0 }} md={{ span: 12 }}>
                    <ImgCars src="https://aaacdndev.blob.core.windows.net/wordpress/2020/03/lined-up-cars.jpg" />
                  </Col>
                  <Col xs={{ span: 24 }}>
                    <SecondaryTitle style={{ textAlign: 'center' }}>
                      See What Makes Us Different!
                    </SecondaryTitle>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row style={{ backgroundColor: '#0000000D', marginTop: 32 }}>
              <CarMobileCol xs={{ span: 24 }} md={{ span: 0 }} />
              <Col xs={{ span: 22, offset: 1 }} md={{ span: 20, offset: 2 }}>
                <Row>
                  <Col xs={{ span: 0 }} md={{ span: 9 }}>
                    <img
                      style={{ height: '100%', width: '100%' }}
                      src="https://aaacdndev.blob.core.windows.net/wordpress/2020/03/four-white-cars.jpg"
                    />
                  </Col>
                  <Col
                    xs={{ span: 24 }}
                    md={{ span: 13, offset: 2 }}
                    style={{ marginTop: 64 }}
                  >
                    <SecondaryTitle>
                      Lifetime Protection For Your Fleet
                    </SecondaryTitle>
                    <p>
                      At AAA Car Care we offer lifetime protection plans that
                      help to keep your vehicle protected even after the
                      manufacturer warranty has expired. Our protection plans
                      cover the major systems of your fleet vehicles and is
                      included in every engine, fuel system, drive line, brake
                      system, cooling system, power steering and automatic
                      transmission fluid service.
                    </p>
                    <p>
                      We offer 2 plans to cover vehicles from 0 – 75,000 miles
                      and cover up to $6,000. You keep coverage on your vehicle
                      just by keeping up with service intervals for each
                      service.
                    </p>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row style={{ paddingBottom: 64 }}>
              <Col xs={{ span: 22, offset: 1 }} md={{ span: 20, offset: 2 }}>
                <Row style={{ marginTop: 64 }}>
                  <Col
                    xs={{ span: 24 }}
                    md={{ span: 12 }}
                    style={{ marginTop: 0 }}
                  >
                    <SecondaryTitle>
                      Total Transparency At Every Visit
                    </SecondaryTitle>
                    <p>
                      At every service visit you get our digital vehicle
                      inspection – AAA Digital Vehicle Insight ® (DVI). This
                      digital inspection gives you a look into your fleet
                      vehicles health by letting you see what the technician
                      sees via a digital report that is sent either by text or
                      email.
                    </p>
                    <CTAButton
                      href="https://carolinas.aaa.com/landing/digital-vehicle-insight/"
                      type="primary"
                      style={{ marginTop: 16, marginBottom: 32 }}
                    >
                      See DVI In Action
                    </CTAButton>
                  </Col>
                  <Col xs={{ span: 24 }} md={{ span: 10, offset: 2 }}>
                    <img
                      style={{ width: '100%' }}
                      src="https://aaacdndev.blob.core.windows.net/wordpress/landing/dvi/phones.png"
                    />
                  </Col>
                </Row>
              </Col>
            </Row>

            <ContactUsFormRow id="contact-us">
              <Col xs={{ span: 22, offset: 1 }} md={{ span: 20, offset: 2 }}>
                <h2>Get Your Fleet Protected with AAA Peace Of Mind</h2>
                <p style={{ marginBottom: 64 }}>
                  Submit your information below and one of our team members will
                  reach out to answer any questions and help you get your fleet
                  setup with AAA!
                </p>

                <Form
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 16 }}
                  form={form}
                  name="Fleet Services Form"
                  style={{ marginTop: 32 }}
                  onFinish={handleFormSubmit}
                  initialValues={{
                    oid: '00Dj0000001q639',
                    retURL:
                      'https://carolinas.aaa.com/car-care-fleet-services/',
                    LeadSource: 'Fleet Web Form',
                    recordType: '0120a0000010OZV',
                  }}
                >
                  <Form.Item name="oid" hidden>
                    <Input />
                  </Form.Item>
                  <Form.Item name="retURL" hidden>
                    <Input />
                  </Form.Item>
                  <Form.Item name="LeadSource" hidden>
                    <Input />
                  </Form.Item>
                  <Form.Item name="recordType" hidden>
                    <Input />
                  </Form.Item>
                  <Form.Item label="Name">
                    <Form.Item
                      name="first_name"
                      htmlFor="first_name"
                      style={{
                        display: 'inline-block',
                        width: 'calc(50% - 8px)',
                        margin: '0px',
                      }}
                      rules={[
                        {
                          required: true,
                          message: 'Please input your first name!',
                          whitespace: true,
                        },
                      ]}
                    >
                      <Input
                        id="first_name"
                        maxLength={40}
                        placeholder="First Name"
                        size="large"
                        type="text"
                      />
                    </Form.Item>

                    <Form.Item
                      name="last_name"
                      htmlFor="last_name"
                      style={{
                        display: 'inline-block',
                        width: 'calc(50% - 8px)',
                        margin: '0 0 0 16px',
                      }}
                      rules={[
                        {
                          required: true,
                          message: 'Please input your last name!',
                          whitespace: true,
                        },
                      ]}
                    >
                      <Input
                        id="last_name"
                        maxLength={80}
                        placeholder="Last Name"
                        size="large"
                        type="text"
                      />
                    </Form.Item>
                  </Form.Item>

                  <Form.Item
                    name="company"
                    label="Company"
                    htmlFor="company"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your company!',
                        whitespace: true,
                      },
                    ]}
                  >
                    <Input
                      id="company"
                      maxLength={40}
                      size="large"
                      type="text"
                    />
                  </Form.Item>

                  <Form.Item
                    name="00N5b00000DOHbg"
                    label="Number of Vehicles"
                    htmlFor="00N5b00000DOHbg"
                    rules={[
                      {
                        required: true,
                        message: 'Please input the number of vehicles!',
                      },
                    ]}
                  >
                    <InputNumber
                      id="00N5b00000DOHbg"
                      size="large"
                      type="number"
                      min={0}
                      style={{
                        width: '100%',
                      }}
                    />
                  </Form.Item>

                  <Form.Item
                    name="phone"
                    label="Phone"
                    htmlFor="phone"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your phone number!',
                      },
                    ]}
                  >
                    <Input id="phone" maxLength={40} size="large" />
                  </Form.Item>

                  <Form.Item
                    name="email"
                    label="Email"
                    htmlFor="email"
                    rules={[
                      {
                        type: 'email',
                        message: 'The input is not valid E-mail!',
                      },
                      {
                        required: true,
                        message: 'Please input your E-mail!',
                      },
                    ]}
                  >
                    <Input id="email" size="large" type="text" />
                  </Form.Item>

                  <Form.Item
                    name="description"
                    label="Description"
                    htmlFor="description"
                  >
                    <Input.TextArea />
                  </Form.Item>

                  <Form.Item wrapperCol={{ offset: 3 }}>
                    <Button type="primary" htmlType="submit" name="submit">
                      Submit
                    </Button>
                  </Form.Item>
                </Form>
              </Col>
            </ContactUsFormRow>
          </Layout>
        </AdsProvider>
      </SettingProvider>
    </ApolloProvider>
  );
};

export default CarCareFleetServicesPage;
